import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { ASSURANT_WEBSITE } from '~/utils/url';
import { GENERAL_CONDITIONS_LINK } from '../../constants';

interface ItemProps {
  label: string;
  value?: string;
}
const Item = ({ label, value }: ItemProps) => (
  <Text className={'font-medium text-gray-400 text-[12px] text-center'}>
    {label}{' '}
    {!!value && <Text className="text-primary-600 font-normal">{value}</Text>}
  </Text>
);

interface Props {
  className?: string;
}

const GeneralInfoFooter: React.FC<Props> = ({ className }) => {
  return (
    <View className={className}>
      {!MarisaAppUtils.isTotem() && (
        <Text className="text-xs text-gray-400 text-center">
          O Plano Odonto é administrado pela{' '}
          <Text
            className="text-primary-600 text-xs font-normal"
            onPress={() => MarisaAppUtils.openUrl(ASSURANT_WEBSITE)}
          >
            SulAmérica
          </Text>
          .
        </Text>
      )}
      <Text className="text-xs text-gray-400 text-center">
        Condições gerais do plano:{' '}
        <Text
          className="text-primary-600 text-xs font-normal"
          onPress={() => MarisaAppUtils.openUrl(GENERAL_CONDITIONS_LINK)}
        >
          Consulte Aqui
        </Text>
      </Text>
      <Text className="text-center text-gray-400 text-[12px] mb-4">
        Carência: 90 dias para tratamentos clínicos, 180 dias para Prótese de
        Rol e 24 horas para urgência e emergência após a adesão.
      </Text>

      <Item label="Atendimento ao cliente 24 horas, 7 dias por semana" />

      <Item label="Serviço de atendimento SAC:" value="3003 1159" />

      <Item label="WhatsApp:" value="11 3003 9723" />

      <View className="mb-4" />

      <Text className="text-center text-gray-400 text-[12px]">
        As informações estão resumidas e poderão sofrer alterações sem aviso
        prévio. Consulte as Condições Gerais do Plano Odontológico e demais
        termos no momento da contratação. Este plano é o Totality INSP
        (divulgado como Plano Odonto), registrado na ANS sob o nº 472248145 e
        garantido pela SulAmérica Odontológico S.A, inscrita no CNPJ/ME sob o no
        11.973.134/0001-05 e registrada na ANS sob o no 417815**. Os benefícios
        aqui mencionados não são uma obrigação contratual e poderão ser
        descontinuados, a exclusivo critério da SulAmérica.
      </Text>
    </View>
  );
};

export default GeneralInfoFooter;
